require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _ToggleButton = _interopRequireDefault(require("./ToggleButton"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/ToggleButton/ToggleButtonRow.tsx";

var ToggleButtonRow = function (_React$Component) {
  (0, _inherits2["default"])(ToggleButtonRow, _React$Component);

  function ToggleButtonRow() {
    (0, _classCallCheck2["default"])(this, ToggleButtonRow);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ToggleButtonRow).apply(this, arguments));
  }

  (0, _createClass2["default"])(ToggleButtonRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          onValueChange = _this$props.onValueChange,
          children = _this$props.children,
          style = _this$props.style;
      var count = React.Children.count(children);
      return React.createElement(_ToggleButton["default"].Group, {
        value: value,
        onValueChange: onValueChange,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57
        }
      }, React.createElement(_reactNative.View, {
        style: [styles.row, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        }
      }, React.Children.map(children, function (child, i) {
        if (child && child.type === _ToggleButton["default"]) {
          return React.cloneElement(child, {
            style: [styles.button, i === 0 ? styles.first : i === count - 1 ? styles.last : styles.middle, child.props.style]
          });
        }

        return child;
      })));
    }
  }]);
  return ToggleButtonRow;
}(React.Component);

(0, _defineProperty2["default"])(ToggleButtonRow, "displayName", 'ToggleButton.Row');

var styles = _reactNative.StyleSheet.create({
  row: {
    flexDirection: 'row'
  },
  button: {
    borderWidth: _reactNative.StyleSheet.hairlineWidth
  },
  first: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  },
  middle: {
    borderRadius: 0,
    borderLeftWidth: 0
  },
  last: {
    borderLeftWidth: 0,
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
});

var _default = ToggleButtonRow;
exports["default"] = _default;